export default __webpack_public_path__ + "static/media/Template_4.f2db0315.svg";